// extracted by mini-css-extract-plugin
export default {"footerWrapper":"footer_footerWrapper__uxvSC","logoText":"footer_logoText__fGKn+","minorText":"footer_minorText__tnpA-"};